import script from "./iconAnimation.vue?vue&type=script&setup=true&lang=js"
export * from "./iconAnimation.vue?vue&type=script&setup=true&lang=js"

import "./iconAnimation.vue?vue&type=style&index=0&id=3210509c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3210509c"]])

export default __exports__